import { CreateAccount } from 'src/components/authentication/create-account';
import { withGuestGuard } from 'src/hocs/with-guest-guard';

import { useTrackPageView } from '@savvy/deprecated-shared/tracking/use-track-page-view';

function CreateAccountPage() {
  useTrackPageView();
  return <CreateAccount />;
}

export default withGuestGuard(CreateAccountPage);
